import { Menu, Row, Typography, Image, Col } from 'antd';

import brasilFlag from '../assets/brasil_flag.svg';
import euaFlag from '../assets/eua_flag.svg';
import spainFlag from '../assets/spain_flag.svg';
import useSetLanguageCookie from '../hooks/useLanguageCookie';
import { changeLanguage } from '../i18n/locale';

const FlagsMenu = () => {
  const { changeLggBackend } = useSetLanguageCookie();

  const handleChangeLanguage = (lgg: string) => {
    switch (lgg) {
      case 'en':
        changeLanguage('en', changeLggBackend);
        break;
      case 'pt':
        changeLanguage('pt', changeLggBackend);
        break;
      case 'es':
        changeLanguage('es', changeLggBackend);
    }
  };

  return (
    <Menu style={{ borderRight: '0' }}>
      <Menu.Item key="br" onClick={() => handleChangeLanguage('pt')}>
        <Row align="middle" gutter={[4, 4]}>
          <Col>
            <Image width={24} src={brasilFlag} preview={false} />
          </Col>
          <Col>
            <Typography.Text>Português (PT)</Typography.Text>
          </Col>
        </Row>
      </Menu.Item>
      <Menu.Item key="us" onClick={() => handleChangeLanguage('en')}>
        <Row align="middle" gutter={[4, 4]}>
          <Col>
            <Image width={24} src={euaFlag} preview={false} />
          </Col>
          <Col>
            <Typography.Text>English (EN)</Typography.Text>
          </Col>
        </Row>
      </Menu.Item>
      <Menu.Item key="es" onClick={() => handleChangeLanguage('es')}>
        <Row align="middle" gutter={[4, 4]}>
          <Col>
            <Image width={24} src={spainFlag} preview={false} />
          </Col>
          <Col>
            <Typography.Text>Español (ES)</Typography.Text>
          </Col>
        </Row>
      </Menu.Item>
    </Menu>
  );
};

export default FlagsMenu;
